import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Contact.css';
import './Home.css';
import logo from './logo.png';

const Contact: React.FC = () => {
  const navigate = useNavigate();
  const [navOpen, setNavOpen] = React.useState(false);
  React.useEffect(() => {
    document.title = 'Liên hệ - Fconnect';
  }, []);
  return (
    <div className="home-page">
      {/* Header (reuse from Home) */}
      <header className="home-header">
        <div className="home-container header-inner">
          <div className="brand" onClick={() => { navigate('/'); setNavOpen(false); } }>
            <img src={logo} alt="Fconnect" />
          </div>
          <button
            className="nav-toggle"
            aria-label={navOpen ? 'Đóng menu' : 'Mở menu'}
            aria-expanded={navOpen}
            aria-controls="main-navigation"
            onClick={() => setNavOpen((o) => !o)}
          >
            {navOpen ? '✕' : '☰'}
          </button>
          <nav id="main-navigation" className={`main-nav ${navOpen ? 'open' : ''}`}>
            <Link to="/" onClick={() => setNavOpen(false)}>Trang chủ</Link>
            <Link to="/lao-dong-pho-thong" onClick={() => setNavOpen(false)}>Lao động phổ thông</Link>
            <Link to="/lao-dong-nong-nghiep" onClick={() => setNavOpen(false)}>Lao động nông nghiệp</Link>
            <Link to="/dich-vu-y-te" onClick={() => setNavOpen(false)}>Dịch vụ y tế</Link>
            <Link to="/privacy" onClick={() => setNavOpen(false)}>Chính sách bảo mật</Link>
            <Link to="/terms" onClick={() => setNavOpen(false)}>Điều khoản</Link>
            <Link to="/contact" onClick={() => setNavOpen(false)}>Liên hệ</Link>
            <Link to="/en" className="lang-link" onClick={() => setNavOpen(false)}>English</Link>
          </nav>
        </div>
      </header>
      <div className={`nav-backdrop ${navOpen ? 'open' : ''}`} onClick={() => setNavOpen(false)} />

      {/* Content */}
      <section className="home-container">
        <header className="contact-header">
          <h1>Liên hệ với chúng tôi</h1>
          <p className="header-subtitle">Chúng tôi luôn sẵn sàng hỗ trợ bạn</p>
        </header>
        <div className="contact-content">
          <section className="contact-section">
            <h2>Thông tin liên hệ</h2>
            <div className="contact-info-grid">
              <div className="contact-card">
                <div className="contact-icon">
                  <span>📧</span>
                </div>
                <h3>Email</h3>
                <p><strong>trile@taichinh-htp.com</strong></p>
                <p>Phản hồi trong vòng 2-4 giờ làm việc</p>
              </div>

              <div className="contact-card">
                <div className="contact-icon">
                  <span>📞</span>
                </div>
                <h3>Điện thoại</h3>
                <p><strong>02513684266</strong></p>
                <p>Hỗ trợ trực tiếp 8:00 - 22:00</p>
              </div>

              <div className="contact-card">
                <div className="contact-icon">
                  <span>📍</span>
                </div>
                <h3>Địa chỉ</h3>
                <p><strong>CÔNG TY CỔ PHẦN TÀI CHÍNH HIỆP TÍN PHÁT</strong></p>
                <p><strong>11/4C, tổ 15, Kp 6</strong></p>
                <p>Phường Trấn Biên</p>
                <p>Tỉnh Đồng Nai, Việt Nam</p>
              </div>

              <div className="contact-card">
                <div className="contact-icon">
                  <span>🕐</span>
                </div>
                <h3>Thời gian làm việc</h3>
                <p><strong>Thứ 2 - Chủ nhật</strong></p>
                <p>8:00 - 22:00</p>
                <p>Hỗ trợ khách hàng 24/7</p>
              </div>
            </div>
          </section>
        </div>
      </section>

      {/* Footer (reuse from Home) */}
      <footer className="home-footer">
        <div className="home-container footer-inner">
          <div className="footer-contact">
            <p><strong>CÔNG TY CỔ PHẦN TÀI CHÍNH HIỆP TÍN PHÁT</strong></p>
            <p><strong>Email:</strong> trile@taichinh-htp.com</p>
            <p><strong>Điện thoại:</strong> 02513684266</p>
            <p><strong>Địa chỉ:</strong> 11/4C, tổ 15, Kp 6, Phường Trấn Biên, Tỉnh Đồng Nai, Việt Nam</p>
            <p><strong>Thời gian hỗ trợ:</strong> 8:00 - 22:00 (Thứ 2 - Chủ nhật)</p>
          </div>
          <div className="footer-stores">
            <a className="store-badge small appstore-badge" href="https://apps.apple.com/vn/app/fconnect-htp/id6752923786?l=vi" target="_blank" rel="noopener noreferrer">
              <span className="badge-icon" aria-hidden="true"></span>
              <span className="badge-text"><span className="badge-sub">Download on the</span><span className="badge-brand">App Store</span></span>
            </a>
            <a className="store-badge small play-badge" href="https://play.google.com/store/apps/details?id=com.taichinhhtp.fconnect&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
              <span className="badge-icon" aria-hidden="true">▶</span>
              <span className="badge-text"><span className="badge-sub">GET IT ON</span><span className="badge-brand">Google Play</span></span>
            </a>
          </div>
        </div>
        <div className="copyright">© 2025 Fconnect. Tất cả các quyền được bảo lưu.</div>
      </footer>
    </div>
  );
};

export default Contact; 